module.exports = __webpack_public_path__ + "static/media/chess-pawn-alt.82bb0091.svg";